module.exports = __webpack_public_path__ + "static/img/caishui.11f7ea4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/data_cate_icon/caishui.png
// module id = 0tLO
// module chunks = 5